import React, { Component } from 'react';
import withRouter from './components/withRouter';
import { Container, Row, Col, Card, Button, Image } from 'react-bootstrap';

import requester from "../library/Requester"; 
import * as util from '../library/utilitys';
import * as Actions from './actions/ActionCenter';

import Header from './components/common/Header';
import Footer from './components/common/Footer';
import styles from '../styles/frontend/News.css';

const VIEW = `frontend_eec_net`;

const NETOPER = `eec_nets_public_network_operation`;
const FUEPLAN = `eec_nets_public_future_plans`;
const PUBDATA = `eec_nets_public_data`;

const URL = `public/view/frontent/tops-info`;
const ATTACH_FILE_CONTENT_URL = `public/view/attach_files/files`;

class EEC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.params?.id || null,
      DataTable1: [],
      DataTable2: [],
      DataTable3: [],
      DataTable4: [],
      DataTable5: [],
      DatatableImage1: {},
      DatatableImage2: {},
    };
  }

  componentDidMount = async () => {
    await this.loadDataToState();
  }

    loadDataToState = async () => {
        try {
            const { id } = this.state;
            const response = await requester.post(`${URL}/${VIEW}`, { id:id , pageSize: 1 });
            const data = response.data?.data?.data?.[0] || response.data?.data?.[0] || null;

            if (data) {
                this.setState({ DataTable1: data }, async () => {
                const imageMap = await Actions.loadImageBlobUrls({
                    rows: [data],
                    fileField: "logo",
                    idField: "id",
                    baseUrl: ATTACH_FILE_CONTENT_URL
                });
                this.setState({ DatatableImage1: imageMap });
                });
                this.setState({ DataTable1: data }, async () => {
                const imageMap = await Actions.loadImageBlobUrls({
                    rows: [data],
                    fileField: "background",
                    idField: "id",
                    baseUrl: ATTACH_FILE_CONTENT_URL
                });
                this.setState({ DatatableImage2: imageMap });
                });

                // ยิง API เพิ่มเติมต่อจาก API หลัก โดยส่ง id ของข้อมูลหลัก (data.id)
                await this.loadOperationData(data.id);

            }
            } catch (error) {
            console.error("Failed to load data by ID:", error);
        }
    };

    // ===== โหลด API ข้อมูลย่อย 3 ตัว พร้อมกัน =====
    loadOperationData = async (mainId) => {
        
        try {
            const [res2, res3, res4, res5] = await Promise.all([
            requester.post(`${URL}/${NETOPER}`, { eec_nets_id: mainId }),
            requester.post(`${URL}/${FUEPLAN}`, { eec_nets_id: mainId }),
            requester.post(`${URL}/${PUBDATA}`, { eec_nets_id: mainId }),
            requester.post(`${URL}/${NETOPER}`, { eec_nets_id: mainId }),
            ]);

            const list2 = res2.data?.data?.data || res2.data?.data || [];
            const list3 = res3.data?.data?.data || res3.data?.data || [];
            const list4 = res4.data?.data?.data || res4.data?.data || [];
            const list5 = res5.data?.data?.data || res5.data?.data || [];
           
            this.setState(
                {
                    DataTable2: list2,
                    DataTable3: list3,
                    DataTable4: list4,
                    DataTable5: list5,
                },
                () => {
                    // callback นี้จะรันหลัง state อัปเดตเสร็จจริง ๆ
                    console.log("this.state (updated)", this.state);
                }
            );
            
        } catch (error) {
            console.error("Failed to load operation data:", error);
        }
    };

  loadImages = async (sourceStateKey, targetImageStateKey = "") => {
    const rows = this.state[sourceStateKey] || [];    
    const getImage = await Actions.loadImageBlobUrls({
      rows,
      fileField: "photo",
      idField: "id",
      baseUrl: ATTACH_FILE_CONTENT_URL
    });
    this.setState({ [targetImageStateKey]: getImage });
  };

  handleMapClick = () => {
    const { DataTable1 } = this.state;
    if (DataTable1?.location) {
      const encodedLocation = encodeURIComponent(DataTable1.location);
      window.open(`https://www.google.com/maps/search/${encodedLocation}`, '_blank');
    } else {
      window.open('https://www.google.com/maps', '_blank');
    }
  };

  render() {
    // const { DataTable1, DatatableImage1, DatatableImage2 } = this.state;
    const { DataTable1, DataTable2, DataTable3, DataTable4, DataTable5, DatatableImage1, DatatableImage2 } = this.state;
    if (!DataTable1) return null;

    const imageLogo = DatatableImage1?.[DataTable1.id] || "/images/default-image.jpg";
    const imageBG = DatatableImage2?.[DataTable1.id] || "/images/default-image.jpg";

    return (
      <div className={styles.pageContainer} style={{ backgroundImage: "url('/images/img__3.png')", backgroundAttachment: 'fixed', backgroundSize: 'cover' }}>
        <Header />

        <Container className="mt-4">
          <Row className="mb-4 text-center">
            <p className="section-subtitle">ศูนย์เครือข่าย</p>
            <h1 className="section-title">{DataTable1?.name}</h1>
          </Row>

          <Row className="justify-content-center py-4">
            <Col xs={12} className="position-relative text-center">
              
              <Image 
                src={imageBG}
                alt="ศูนย์ EEC"
                className="img-fluid"
                style={{ width: '100%', maxHeight: '500px', objectFit: 'cover', borderRadius: '24px' }}
              />
              <div 
                style={{
                  position: 'absolute',
                  bottom: '-60px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  backgroundColor: '#fff',
                  borderRadius: '1.25rem',
                  padding: '0.5rem',
                  boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                  width: '180px',
                  height: '180px',
                  overflow: 'hidden',
                }}
              >
                <div
                  style={{
                    width: '100%',
                    height: '100%',
                    borderRadius: '0.75rem',
                    overflow: 'hidden',
                  }}
                >
                  <Image
                    // src="/images/EEC-logo-yt.png" // ใช้รูปเดียวกันทุกอัน
                    src={imageLogo}
                    // src="/images/img_sealofkmutnbsvg_1.png"
                    alt="KMUTNB Seal"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      display: 'block',
                    }}
                  />
                </div>
              </div>
            </Col>
          </Row>

          <Row className="px-3 py-4 mt-6 justify-content-center" style={{ marginTop: '60px' }}>
            {/* <Col lg={8} className="mb-4">
                <Card className="mb-4">
                    <Card.Body>
                    <div className="news-content">
                        <h2 className="section-heading">{DataTable1?.name}</h2>
                        <p>{DataTable1?.description}</p>
                        <hr/>

                        <h3 className="section-subheading">สถานศึกษา</h3>
                        <ul>
                        <li>{DataTable1?.academy_name}</li>
                        </ul>
                    </div>
                    </Card.Body>
                </Card>
            </Col> */}
            <Col lg={8} className="mb-4">
                <Card className="mb-4">
                    <Card.Body>
                    <div className="news-content">
                        <h2 className="section-heading">{DataTable1?.name}</h2>
                        <p>{DataTable1?.description}</p>
                        <hr/>

                        <h3 className="section-subheading">สถานศึกษา</h3>
                        <ul>
                        <li>{DataTable1?.academy_name}</li>
                        </ul>

                        {/* ===== เซสชันใหม่: รายละเอียดสถานศึกษา จาก DataTable4 ===== */}
                        {DataTable1 && DataTable1.length > 0 && (
                        <>
                            <hr/>
                            {DataTable1.map((item, index) => (
                            <div key={item.id || index} className="academy-detail-item mb-3">
                                <h4 className="section-subheading">{item.name}</h4>
                                <p><strong>สถานศึกษา:</strong> {item.academy_name}</p>
                                <p><strong>รายละเอียด:</strong> {item.description}</p>
                                <p><strong>ที่ตั้ง:</strong> {item.location}</p>
                                <p><strong>ติดต่อ:</strong> {item.contact}</p>
                                <p><strong>อีเมล:</strong> {item.email}</p>
                            </div>
                            ))}
                        </>
                        )}
                    </div>
                    </Card.Body>
                </Card>

                {/* การดำเนินการของศูนย์ */}
                <Card className="mb-4">
                    <Card.Body>
                        <div className="news-content">
                        <h3 className="section-subheading">การดำเนินการของศูนย์</h3>
                        <hr/>

                        {DataTable2 && DataTable2.length > 0 ? (
                            <div className="operation-list">
                            {DataTable2.map((item, index) => (
                                <div
                                key={item.network_operation_id || index}
                                className="operation-item pb-3 mb-3"
                                style={{ borderBottom: index !== DataTable2.length - 1 ? '1px solid #eee' : 'none' }}
                                >
                                <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
                                    <h5 className="mb-1">{item.network_operation_name}</h5>
                                    {item.network_operation_years && (
                                    <span className="badge bg-secondary">ปี {item.network_operation_years}</span>
                                    )}
                                </div>
                                {item.description && <p className="mb-1 text-muted">{item.description}</p>}
                                {item.result && <p className="mb-0">{item.result}</p>}
                                </div>
                            ))}
                            </div>
                        ) : (
                            <p className="text-muted mb-0">ไม่มีข้อมูลการดำเนินการ</p>
                        )}
                        </div>
                    </Card.Body>
                </Card>

                {/* แผนการดำเนินงาน */}
                <Card className="mb-4">
                    <Card.Body>
                        <div className="news-content">
                        <h3 className="section-subheading">แผนการดำเนินงาน</h3>
                        <hr/>

                        {DataTable3 && DataTable3.length > 0 ? (
                            <div className="plan-list">
                            {DataTable3.map((item, index) => (
                                <div
                                key={item.id || index}
                                className="plan-item pb-3 mb-3"
                                style={{ borderBottom: index !== DataTable3.length - 1 ? '1px solid #eee' : 'none' }}
                                >
                                <h5 className="mb-1">{item.future_plans_name}</h5>
                                {item.description && <p className="mb-0 text-muted">{item.description}</p>}
                                </div>
                            ))}
                            </div>
                        ) : (
                            <p className="text-muted mb-0">ไม่มีข้อมูลแผนการดำเนินงาน</p>
                        )}
                        </div>
                    </Card.Body>
                </Card>

               {/* เอกสารเผยแพร่ */}
<Card className="mb-4">
  <Card.Body>
    <div className="news-content">
      <h3 className="section-subheading">เอกสารเผยแพร่</h3>
      <hr/>

      {DataTable4 && DataTable4.length > 0 ? (
        <div className="document-list">
          {DataTable4.map((item, index) => (
            <div
              key={item.id || index}
              className="document-item pb-3 mb-3"
              style={{ borderBottom: index !== DataTable4.length - 1 ? '1px solid #eee' : 'none' }}
            >
              {/* หัวข้อเอกสาร */}
              <h6 className="mb-1">{item.title}</h6>

              {/* รายละเอียดเอกสาร */}
              {item.description && (
                <p className="mb-1 text-muted">{item.description}</p>
              )}

              {/* เอกสารเผยแพร่/นำเสนอ (ไฟล์แนบ) */}
              {item.file_name && (
                <div className="d-flex align-items-center gap-2">
                  <i className="bi bi-paperclip text-secondary" />
                  
                    href={`${ATTACH_FILE_CONTENT_URL}/${item.id}/${item.file_name}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.file_name}
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <p className="text-muted mb-0">ไม่มีเอกสารเผยแพร่</p>
      )}
    </div>
  </Card.Body>
</Card>
            </Col>

            <Col lg={4} className="mb-4">
              <div className="sidebar-box">
                {DataTable1?.location && (
                  <>
                    <div className="sidebar-item">
                      <img src="/images/img_call.svg" alt="Phone" className="icon" />
                      <span className="label">ติดต่อ</span>
                      <p className="value">โทรศัพท์ {DataTable1?.contact}</p>
                    </div>

                    <div className="sidebar-item">
                      <img src="/images/img_sms.svg" alt="Email" className="icon" />
                      <span className="label">อีเมล</span>
                      <p className="value">{DataTable1?.email}</p>
                    </div>

                    <div className="sidebar-item">
                      <img src="/images/img_vuesax_bold_location.svg" alt="Location" className="icon" />
                      <span className="label">ที่ตั้ง</span>
                      <p className="value">{DataTable1?.location}</p>
                    </div>
                  </>
                )}

                <Button 
                  onClick={this.handleMapClick}
                  className="w-100 bg-global-12 text-global-6 border border-global-12 d-flex align-items-center justify-content-center gap-2"
                >
                  <img src="/images/img_map.svg" alt="Map" className="me-2" />
                  ไปยังแผนที่
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default withRouter(EEC);